import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatErr } from "@/lib/api";

export function ModApplyDialog({ open, onOpenChange, onDone }) {
  const [f, setF] = useState({ motivation: "", hours: "", experience: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const send = async () => {
    setBusy(true);
    try {
      await api.post("/staff/apply", f);
      toast.success("Bewerbung gesendet 💖", { description: "Wir melden uns bei dir, sobald wir sie geprüft haben." });
      onOpenChange(false);
      onDone();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-3xl text-left" data-testid="mod-apply-dialog">
        <DialogHeader>
          <DialogTitle>Als Moderator bewerben</DialogTitle>
          <DialogDescription>Erzähl uns kurz von dir – die Projektleitung liest jede Bewerbung persönlich.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5"><Label className="text-xs">Warum möchtest du Moderator werden? *</Label>
            <Textarea rows={4} value={f.motivation} onChange={set("motivation")} placeholder="Mindestens 30 Zeichen" data-testid="mod-apply-motivation" />
            <p className="text-[11px] text-slate-400 text-right">{f.motivation.trim().length}/30</p></div>
          <div className="space-y-1.5"><Label className="text-xs">Wie viel Zeit hast du pro Woche? *</Label>
            <Input value={f.hours} onChange={set("hours")} placeholder="z. B. 5 Stunden, abends" data-testid="mod-apply-hours" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Erfahrung (optional)</Label>
            <Textarea rows={3} value={f.experience} onChange={set("experience")} placeholder="z. B. Moderation in anderen Gruppen" data-testid="mod-apply-experience" /></div>
          <button type="button" onClick={send} disabled={busy || f.motivation.trim().length < 30 || !f.hours.trim()} className="w-full h-12 rounded-full pink-gradient text-white font-bold inline-flex items-center justify-center gap-2 disabled:opacity-50" data-testid="mod-apply-submit">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Bewerbung absenden
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
